module.exports = __webpack_public_path__ + "img/9ca6e47.png";